import { useState, useEffect, useRef } from 'react';

const DESKTOP_BREAKPOINT = 1024;
const HEADER_HEIGHT = 56; // h-14 = 56px
const BOTTOM_NAV_HEIGHT = 64; // h-16 = 64px

export function useScrollDirection() {
  const [headerOffset, setHeaderOffset] = useState(0);
  const [bottomNavOffset, setBottomNavOffset] = useState(0);
  const [isDesktop, setIsDesktop] = useState(false);
  const lastScrollY = useRef(0);

  // Detect desktop vs mobile
  useEffect(() => {
    const checkDesktop = () => {
      setIsDesktop(window.innerWidth >= DESKTOP_BREAKPOINT);
    };

    checkDesktop();
    window.addEventListener('resize', checkDesktop);
    return () => window.removeEventListener('resize', checkDesktop);
  }, []);

  // Handle scroll-linked translation
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = Math.max(0, window.scrollY);
      const delta = currentScrollY - lastScrollY.current;

      // Update offsets based on scroll delta
      setHeaderOffset((prev) => {
        const next = prev + delta;
        return Math.max(0, Math.min(HEADER_HEIGHT, next));
      });

      setBottomNavOffset((prev) => {
        const next = prev + delta;
        return Math.max(0, Math.min(BOTTOM_NAV_HEIGHT, next));
      });

      lastScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return { headerOffset, bottomNavOffset, isDesktop };
}
